import React, { useState } from "react";
import "./PostaniClan.css"; 
import { useTranslation } from "react-i18next";

function PostaniClan() {
    const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    email: "",
    message: ""
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("Sending...");
  
    fetch("/contact.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        name: formData.name,
        surname: formData.surname,
        email: formData.email,
        message: formData.message,
      }),
    })
      .then((response) => response.text())
      .then((data) => {
        setStatus(data);
        
        if (data.includes("Sporočilo uspešno poslano")) {  
          setFormData({
            name: "",
            surname: "",
            email: "",
            message: "",
          }); 
        }
      })
      .catch((error) => {
        console.error("Error sending email:", error);
        setStatus("Failed to send email.");
      });
  };

  return (
    <div className="postaniclancelkontejner">
      <form className="contact-form" onSubmit={handleSubmit}>
        <center>
          <h2>{t("contact_form_title")}</h2>
          <p>{t("contact_form_subtitle")}</p>
        </center>
        <input
          className="contact-form__input"
          type="text"
          name="name"
          placeholder={t("form_name_placeholder")}
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          className="contact-form__input"
          type="text"
          name="surname"
          placeholder={t("form_surname_placeholder")}
          value={formData.surname}
          onChange={handleChange}
          required
        />
        <input
          className="contact-form__input"
          type="email"
          name="email"
          placeholder={t("form_email_placeholder")}
          value={formData.email}
          onChange={handleChange}
          required
        />
        <textarea
          className="contact-form__textarea"
          name="message"
          placeholder={t("form_message_placeholder")}
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>
        <button className="contact-form__button" type="submit">
          {t("form_send_button")}
        </button>
        <p className="contact-form__status">{status}</p>
      </form>
    </div>
  );
}

export default PostaniClan;